module.exports = __webpack_public_path__ + "static/media/logo-internal-retina.6a1633d8.png";